module.exports = __webpack_public_path__ + "static/media/palate.66b096c5.jpg";